import * as yup from 'yup';
import calculateAge from '../../../core/constant/utils/helper';

export const basicContactSchema = yup.object({
  phoneNumber: yup.string().required('Phone number is required'),
  partnerId: yup.string().optional().default('NONE'),
  memberSource: yup.string().optional(),
});

export const personalDetailsSchema = yup.object({
  firstName: yup.string().required('First name is required'),
  lastName: yup.string().required('Last name is required'),
  preferredName: yup.string().optional(),
  email: yup.string().email('Please enter a valid email address').required('Email is required'),
  dob: yup.string().required('Date of birth is required'),
  races: yup
    .mixed<string[]>()
    .test(
      'is-string-array',
      'Must be an array of strings',
      (value) => !value || (Array.isArray(value) && value.every((item) => typeof item === 'string'))
    )
    .optional(),
  sexualOrientation: yup.string().optional(),
  pronouns: yup
    .mixed<string[]>()
    .test(
      'is-string-array',
      'Must be an array of strings',
      (value) => !value || (Array.isArray(value) && value.every((item) => typeof item === 'string'))
    )
    .optional(),
  gender: yup.string().optional(),
  address: yup.string().required(),
  state: yup.string().optional(),
  city: yup.string().optional(),
  zip: yup.string().optional(),
  isStudent: yup.boolean().optional(),
  school: yup.string().when('isStudent', ([isStudent], schema) => {
    return isStudent
      ? schema.required('School is required for students')
      : schema.optional();
  }),
  // preferredLanguage: yup.string().optional(),
});

export const preferenceInformationSchema = yup.object({
  hopeToGain: yup.string().optional(),
  preferredPartnerId: yup.string().nullable().optional(),
  preferredPartnerName: yup.string().nullable().optional(),
  preferredCoachGenders: yup.string().optional(),
  preferredCoachEthnicities: yup
    .mixed<string[]>()
    .test(
      'is-string-array',
      'Must be an array of strings',
      (value) => !value || (Array.isArray(value) && value.every((item) => typeof item === 'string'))
    )
    .optional(),
  preferredCoachSexualOrientations: yup.string().optional(),
});

// Step 4: Schedule
export const scheduleSchema = yup.object({
  shiftTime: yup.string().required('Preferred time for coaching is required'),
  shiftDays: yup
    .mixed<string[]>()
    .test(
      'is-string-array',
      'Must be an array of strings',
      (value) => !value || (Array.isArray(value) && value.every((item) => typeof item === 'string'))
    )
    .required('Please select at least one day'),
  preferredCoachGenders: yup.string().optional(),
  preferredCoachEthnicities: yup
    .mixed<string[]>()
    .test(
      'is-string-array',
      'Must be an array of strings',
      (value) => !value || (Array.isArray(value) && value.every((item) => typeof item === 'string'))
    )
    .optional(),
  preferredCoachSexualOrientations: yup.string().optional(),
});

export const emergencyContactLessThanEighteenSchema = yup.object({
  contactName: yup.string().required('Emergency contact name is required').min(2, 'Emergency contact name must be at least 2 characters'),
  contactPhone: yup.string().required('Emergency contact phone is required').min(10, 'Phone number must be at least 10 digits'),
  contactRelationship: yup.string().required('Relationship to contact is required').min(2, 'Relationship to contact must be at least 2 characters'),
});

export const emergencyContactGreaterThanEighteenSchema = yup.object({
  contactName: yup.string().optional(),
  contactPhone: yup.string().test(
    'phone-format',
    'Phone number must be exactly 10 digits',
    (value) => !value || value.length === 0 || /^\d{10}$/.test(value)
  ),
  contactRelationship: yup.string().optional(),
});

export const getValidationSchemaForStep = (step: number, dob?: string): yup.ObjectSchema<any> => {
  switch (step) {
    case 0:
      return basicContactSchema;
    case 1:
      return personalDetailsSchema;
    default:
      return yup.object().shape({});
  }
};
export const getValidationSchemaForStep2 = (step: number, dob?: string): yup.ObjectSchema<any> => {
  switch (step) {
    case 0:
      return preferenceInformationSchema;
    case 1:
      return scheduleSchema;
    case 2:
      if (dob) {
        const age = calculateAge(dob) || 0;
        if (age < 18) {
          return emergencyContactLessThanEighteenSchema;
        }
      }
      return emergencyContactGreaterThanEighteenSchema;
    
    

    default:
      return yup.object().shape({});
  }
}